<template>
  <div>
    <div class="mx-4 mb-5 create_account_form_navs">
      <ul role="tablist" class="nav nav-pills nav-fill">
        <li role="presentation" class="nav-item mr-2">
          <a role="tab" class="nav-link rounded-pill create_account_form_tab" :class="{ active: activeTab >= 1 }"></a>
        </li>
        <li role="presentation" class="nav-item mx-2">
          <a role="tab" class="nav-link rounded-pill create_account_form_tab" :class="{ active: activeTab >= 2 }"></a>
        </li>
        <li role="presentation" class="nav-item ml-2">
          <a role="tab" class="nav-link rounded-pill create_account_form_tab" :class="{ active: activeTab >= 3 }"></a></li>
      </ul>
    </div>

    <div v-show="activeTab == 1">
      <form @submit.prevent="onSubmitTab1('tab1Form')" autocomplete="off" data-vv-scope="tab1Form">
        <div class="form-group">
          <input 
            type="text" 
            name="first name" 
            id="first_name" 
            ref="first_name"
            v-validate="{ rules: { required: true, regex: nameRegex() } }" 
            maxlength="250" 
            v-model="create_account_obj.first_name"
            class="form-control" 
            placeholder="First Name">
          <div v-if="verrors.firstByRule('tab1Form.first name', 'required')" class="margin-bottom-5 validate-warning-msg">
            The first name field is required</div>
          <div v-if="verrors.firstByRule('tab1Form.first name', 'regex')" class="margin-bottom-5 validate-warning-msg">
            First name should only contain - and _</div>
        </div>

        <div class="form-group">
          <input 
            type="text" 
            name="last name" 
            id="last_name" 
            ref="last_name"
            v-validate="{ rules: { required: true, regex: nameRegex() } }" 
            maxlength="250" 
            v-model="create_account_obj.last_name"
            class="form-control" 
            placeholder="Last Name">
          <div v-if="verrors.firstByRule('tab1Form.last name', 'required')" class="margin-bottom-5 validate-warning-msg">
            The last name field is required</div>
          <div v-if="verrors.firstByRule('tab1Form.last name', 'regex')" class="margin-bottom-5 validate-warning-msg">Last
            name should only contain - and _</div>
        </div>

        <div class="form-group">
          <input 
            type="text" 
            name="email" 
            id="email" 
            ref="email"
            v-validate="{ rules: { required: true, email: true } }" 
            maxlength="250" 
            v-model="create_account_obj.email"
            class="form-control" 
            placeholder="Email">
          <div v-if="verrors.firstByRule('tab1Form.email', 'required')" class="margin-bottom-5 validate-warning-msg">The
            email field is required</div>
          <div v-if="verrors.firstByRule('tab1Form.email', 'email')" class="margin-bottom-5 validate-warning-msg">The email
            field must be a valid email</div>
          <div v-if="verrors.firstByRule('tab1Form.email', 'exists')" class="margin-bottom-5 validate-warning-msg">Email address already exists</div>
        </div>

        <div class="form-group">
          <input 
            type="password" 
            name="password" 
            id="password" 
            ref="password" 
            v-validate="'required|min:10|special_char|number'"
            maxlength="20" 
            v-model="create_account_obj.password" 
            class="form-control" 
            placeholder="Create a Password">
          <div v-show="verrors.has('tab1Form.password')" class="validate-warning-msg d-none">{{ verrors.first('tab1Form.password') }}</div>

          <div 
            class="ml-2 mt-2" 
            :class="create_account_obj.password && passwordLengthValid ? 'text-success' : (create_account_obj.password && !passwordLengthValid ? 'text-danger' : 'text-muted')">
            <i 
              class="fa mr-1" 
              :class="create_account_obj.password && passwordLengthValid ? 'fa-check-circle' : (create_account_obj.password && !passwordLengthValid ? 'fa-times' : '')"></i>
            10 or more characters
          </div>

          <div 
            class="ml-2" 
            :class="create_account_obj.password && containsSpecialChar ? 'text-success' : (create_account_obj.password && !containsSpecialChar ? 'text-danger' : 'text-muted')">
            <i 
              class="fa mr-1" 
              :class="create_account_obj.password && containsSpecialChar ? 'fa-check-circle' : (create_account_obj.password && !containsSpecialChar ? 'fa-times' : '')"></i>
            1 or more special characters (*,!,#, etc)
          </div>

          <div 
            class="ml-2 mb-0" 
            :class="create_account_obj.password && containsNumber ? 'text-success' : (create_account_obj.password && !containsNumber ? 'text-danger' : 'text-muted')">
            <i 
              class="fa mr-1" 
              :class="create_account_obj.password && containsNumber ? 'fa-check-circle' : (create_account_obj.password && !containsNumber ? 'fa-times' : '')"></i>
            1 or more numbers
          </div>
        </div>

        <div class="form-group">
          <input 
            type="password" 
            name="confirm_password" 
            id="confirm_password" 
            ref="confirm_password" 
            v-validate="'required|confirmed:password|min:6'"
            maxlength="20" 
            v-model="create_account_obj.confirm_password" 
            class="form-control" 
            placeholder="Confirm Password">
          <div v-show="verrors.has('tab1Form.confirm_password')" class="d-none validate-warning-msg">{{ verrors.first('confirm_password') }}</div>
          <div v-if="verrors.firstByRule('tab1Form.confirm_password', 'required')" class="margin-bottom-5 validate-warning-msg">
            The confirm password field is required</div>
          <div v-if="verrors.firstByRule('tab1Form.confirm_password', 'confirmed')" class="margin-bottom-5 validate-warning-msg">The confirm password confirmation does not match</div>                  
        </div>

        <div class="text-center mt-3">
          <button type="submit" class="btn btn-lg btn-blue text-center px-5">Next</button>
        </div>
      </form>
    </div>    

    <div v-show="activeTab == 2">
      <form @submit.prevent="onSubmitTab2('tab2Form')" autocomplete="off" data-vv-scope="tab2Form">

        <div class="form-group" id="industry-wrapper">
          <select 
            name="industry_type" 
            id="industry_type" 
            ref="industry_type" 
            v-validate="'required'"
            v-model="create_account_obj.industry_type" 
            class="form-control industry_type">
            <option v-for="(industry, index) in industry_options" :key="industry.id" :value="industry.id">{{
              industry.text }}
            </option>
          </select>
          <div v-if="verrors.firstByRule('tab2Form.industry_type', 'required')" class="validate-warning-msg">The
            industry field is required</div>
        </div>

        <div class="form-group" id="role-wrapper">
          <select 
            name="role" 
            id="role" 
            ref="role" 
            v-model="create_account_obj.role"
            class="form-control role">
            <option v-for="(role, index) in role_options" :key="'role_' + index" :value="role.value">{{ role.text
            }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <input 
            type="number" 
            min="0"
            name="no_of_locations" 
            id="no_of_locations" 
            ref="no_of_locations"
            v-validate="'required'" 
            v-model="create_account_obj.no_of_locations" 
            class="form-control"
            placeholder="Number of locations?">
          <div v-show="verrors.has('tab2Form.no_of_locations')" class="validate-warning-msg">The number of locations field is required</div>
        </div>

        <div class="form-group px-2">
          <label for="" class="font-weight-bold h6">Do you currently have a mentoring or apprenticing
            program?</label>
          <div class="custom-control custom-radio custom-control-inline">
            <input 
              type="radio" 
              id="have_program_yes" 
              name="have_program" 
              class="custom-control-input"
              v-model="create_account_obj.have_program" 
              ref="have_program_yes"
              value="1">
            <label 
              class="custom-control-label" 
              for="have_program_yes">Yes</label>
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input 
              type="radio" 
              id="have_program_no" 
              name="have_program" 
              class="custom-control-input"
              v-model="create_account_obj.have_program" 
              ref="have_program_no"
              value="0">
            <label 
              class="custom-control-label" 
              for="have_program_no">No</label>
          </div>
        </div>

        <div class="text-center mt-3">
          <button type="submit" class="btn btn-lg btn-blue text-center px-5">Next</button>
        </div>
      </form>
    </div>

    <div v-show="activeTab == 3">
      <form  @submit.prevent="onSubmitTab3('tab3Form')" autocomplete="off" data-vv-scope="tab3Form">
        <div class="form-group">
          <input 
            name="location_api" 
            id="location_api" 
            ref="location_api" 
            class="form-control address-search-icon-"
            placeholder="Search Company" 
            onfocus="value = ''" 
            value=""
            style="border: 0; border-bottom: 1px solid #ced4da;">
        </div>

        <div class="form-group">
          <input 
            type="text" 
            name="account name" 
            id="account_name" 
            ref="account_name"
            v-validate="{ rules: { required: true } }" 
            maxlength="250" 
            v-model="create_account_obj.account_name"
            class="form-control" 
            placeholder="Company Name">
          <div v-if="verrors.firstByRule('tab3Form.account name', 'required')" class="margin-bottom-5 validate-warning-msg">
            The company name field is required</div>
          <div v-if="verrors.firstByRule('tab3Form.account name', 'exists')" class="margin-bottom-5 validate-warning-msg">Company name already exists</div>
        </div>

        <div class="form-group">
          <select 
            name="country"
            id="org_country"
            ref="org_country"                    
            v-model="create_account_obj.org_country"
            v-validate="'required'" 
            v-on:change="getStateLists(create_account_obj.org_country)"
            class="form-control">
                <option v-for="(type, index) in country_options" :key="index" :value="type.value">{{ type.text }}</option>
            </select>
          <div v-show="verrors.has('tab3Form.country')" class="validate-warning-msg">{{ verrors.first('country') }}</div>
        </div> 

        <div class="form-group">
          <input 
            name="address" 
            id="org_address"
            ref="org_address"
            v-validate="'required'"
            maxlength="250" 
            v-model="create_account_obj.org_address"
            class="form-control" 
            placeholder="Address 1">
          <div v-if="verrors.firstByRule('tab3Form.address', 'required')" class="margin-bottom-5 validate-warning-msg">The address 1 field is required</div>
        </div>

        <div class="form-group">
          <input 
            type="text" 
            name="mailing_address_2" 
            id="mailing_address_2"
            ref="mailing_address_2"
            v-model="create_account_obj.mailing_address_2"
            class="form-control" 
            placeholder="Address 2"
            maxlength="250">
        </div>

        <div class="form-group">
          <input 
            type="text"
            name="city" 
            id="org_city"
            ref="org_city"
            v-validate="'required'"
            maxlength="100" 
            v-model="create_account_obj.org_city" 
            class="form-control" 
            placeholder="City">
            <div v-show="verrors.has('tab3Form.city')" class="validate-warning-msg">{{ verrors.first('city') }}</div>
        </div>  

        <div class="form-group">
          <select 
            name="state" 
            id="org_state"
            ref="org_state"
            v-validate="'required'" 
            v-model="create_account_obj.org_state" 
            class="form-control">
            <option v-for="(type, index) in state_options" :key="index" :value="type.value">{{ type.text }}</option>
          </select>
          <div v-if="verrors.firstByRule('tab3Form.state', 'required')" class="margin-bottom-5 validate-warning-msg">The state field is required</div>
        </div>                          

        <div class="form-group">
          <input 
            type="text" 
            name="zip" 
            id="org_zip"
            ref="org_zip"
            v-validate="{ rules: { required: true, regex: getPostalCodeRegex() } }"
            v-model="create_account_obj.org_zip"
            maxlength="10"
            class="form-control" 
            placeholder="Zip Code">
          <div v-if="verrors.firstByRule('tab3Form.zip', 'required')" class="margin-bottom-5 validate-warning-msg">The zip code field is required</div>
          <div v-if="verrors.firstByRule('tab3Form.zip', 'regex')" class="margin-bottom-5 validate-warning-msg">The zip code format is invalid</div>
        </div> 

        <div class="form-group">
          <input 
            type="text" 
            name="phone" 
            id="phone_number"
            ref="phone_number"
            v-validate="{ rules: { required: true, regex: phoneRegex() } }"
            maxlength="14"
            v-model="create_account_obj.phone_number"
            @keyup="phoneValid"
            @blur="phoneValid"
            class="form-control" 
            placeholder="Phone">                                
            <div v-if="verrors.firstByRule('tab3Form.phone', 'required')" class="margin-bottom-5 validate-warning-msg">The phone number field is required</div>
            <div v-if="verrors.firstByRule('tab3Form.phone', 'regex')" class="margin-bottom-5 validate-warning-msg">The phone number format is invalid</div>
      </div> 

        <div class="text-center mt-3">
          <button type="submit" class="btn btn-lg btn-blue text-center px-5">Next</button>
        </div>
        
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import { Validator } from 'vee-validate';
import { store } from '../../store/store';
import router from '../../router/index.js';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields' });

Validator.extend('special_char', {
  getMessage: field => `The ${field} field must contain at least one special character.`,
  validate: value => /[!@#$%^&*]/.test(value)
});

Validator.extend('number', {
  getMessage: field => `The ${field} field must contain at least one number.`,
  validate: value => /[0-9]/.test(value)
});

export default {
  data() {
    return {
      activeTab: 1,
      create_account_obj: {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        confirm_password: '',
        account_name: '',
        role: '',
        industry_type: '',
        no_of_locations: '',
        have_program: '',
        org_address: '',
        org_country: 'US',
        mailing_address_2: '',
        org_city: '',
        org_state: '',
        org_zip: '',
        phone_number: '',
      },

      industry_options: [{
        id: '',
        text: 'Industry',
      }],
      role_options: [{
        value: '',
        text: 'Your role?',
      }, {
        value: 'General Manager',
        text: 'General Manager',
      }],

      country_options: [],
      state_options: [],
    }
  },
  computed: {
    passwordLengthValid() {
      return this.create_account_obj.password.length >= 10;
    },
    containsSpecialChar() {
      return /[!@#$%^&*]/.test(this.create_account_obj.password);
    },
    containsNumber() {
      return /[0-9]/.test(this.create_account_obj.password);
    }
  },
  methods: {
    phoneValid: function(event) {
      var phone = this.create_account_obj.phone_number;
      this.create_account_obj.phone_number = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    },        
    phoneRegex: function() {
      return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    },
    nameRegex: function () {
      return /^[a-zA-Z-_ ']*$/;
    },
    onSubmitTab1(scope) {
      this.create_account_error_msg = '';
      this.$validator.validateAll(scope).then((result) => {
        if (!result) {
          console.log("ERROR" + result)
          return;
        }
        else {
            axios('/custom/checkEmailExists/' + this.create_account_obj.email,
            {
                method: 'GET', 
            })
            .then(response => {                
                this.activeTab = 2;
                this.$store.dispatch('create_account_obj', this.create_account_obj);
            })
            .catch(error => {
              const fieldErrors =  [];
              var error_msg = error.response.data.message;
              var data_array = error_msg.split(',');
              for(var i=0; i<data_array.length; i++) {
                var data_array_value = data_array[i];
                data_array_value = data_array_value.replace("{", "");
                data_array_value = data_array_value.replace("}", "");
                data_array_value = "{"+data_array_value+"}";
                var errMsgObj = JSON.parse(data_array_value);
                Object.keys(errMsgObj).map(key => {
                  var fieldName = scope+'.'+key;
                  var newFieldErr = {field:fieldName, msg:errMsgObj[key], rule:'exists'};
                  fieldErrors.push(newFieldErr);
                  this.$validator.errors.add(fieldErrors);
                });
              }
            });


        }
        
      }).catch(() => {
        // catches the error;
      });
    },
    fetchIndustryOptions: function () {
      axios.get('/custom/industryoptions', {

      })
        .then((response) => {
          for (var i = 0; i < response.data.industry.length; i++) {
            // var industry_option = { value: response.data.industry[i].id, text: response.data.industry[i].title };
            var industry_option = {
              id: response.data.industry[i].id,
              text: response.data.industry[i].title,
            };
            this.industry_options.push(industry_option);
          }
        })
        .catch(error => {

        });

    },
    onSubmitTab2(scope) {
      this.create_account_error_msg = '';
      this.$validator.validateAll(scope).then((result) => {
        if (!result) {
          console.log("ERROR" + result)
          console.log(this.verrors);
          return;
        }
        else {
          this.activeTab = 3;
          this.$store.dispatch('create_account_obj', this.create_account_obj);
        
          /*
            axios('/custom/checkAccountNameExists/' + this.create_account_obj.account_name,
            {
                method: 'GET', 
            })
            .then(response => {                
                this.activeTab = 3;
                this.$store.dispatch('create_account_obj', this.create_account_obj);
            })
            .catch(error => {
              const fieldErrors =  [];
              var error_msg = error.response.data.message;
              var data_array = error_msg.split(',');
              for(var i=0; i<data_array.length; i++) {
                var data_array_value = data_array[i];
                data_array_value = data_array_value.replace("{", "");
                data_array_value = data_array_value.replace("}", "");
                data_array_value = "{"+data_array_value+"}";
                var errMsgObj = JSON.parse(data_array_value);
                Object.keys(errMsgObj).map(key => {
                  var fieldName = scope+'.'+key;
                  var newFieldErr = {field:fieldName, msg:errMsgObj[key], rule:'exists'};
                  fieldErrors.push(newFieldErr);
                  this.$validator.errors.add(fieldErrors);
                });
              }
            });
          */

        }

      }).catch(() => {
        // catches the error;
      });
    },
    insertAccountUserAction() {

            axios('/custom/create-account-insert',
            {
                method: 'POST',
                data: {
                    "account": {
                        "company_name": this.create_account_obj.account_name,
                        "master_admin": false,
                        "school_flag": 'Company',
                        "website": '',
                        "phone_no": '',
                        "phone_ext": '',
                        "fax": '',
                        "status": 'Inactive',                       
                        "researcher_notes": '',
                        "naics_code": '',
                        "naics_id": '',
                        "naics_description": '',
                        "naics_label": '',
                        "location": {
                            "address": this.create_account_obj.org_address,
                            "country_code": this.create_account_obj.org_country,
                            "state_code": this.create_account_obj.org_state,
                            "city": this.create_account_obj.org_city,
                            "zip": this.create_account_obj.org_zip,
                            "market_area": '',
                            "address2": this.create_account_obj.mailing_address_2
                        },
                        "program": 'Mentorship',
                        "industry_selected": this.create_account_obj.industry_type,
                        "is_customer_created_account": 1, 
                        "no_of_locations": this.create_account_obj.no_of_locations,
                        "have_program": this.create_account_obj.have_program,
                    },
                    "userInfo": {
                        "uid": 0,
                        'admin_fname': this.create_account_obj.first_name,
                        'admin_lname': this.create_account_obj.last_name,
                        'admin_email': this.create_account_obj.email,
                        'password': this.create_account_obj.password,
                        "phone": this.create_account_obj.phone_number,
                        "phone_ext": '',
                        "mobile": '',                       
                        'id_number': '',
                        'admin_title': this.create_account_obj.role,
                        'is_enabled': 0,                       
                        'remove_flag': false,
                        'last_login': "",
                        'no_login': "",                       
                        'is_primaryadmin': 1,                       
                        'is_manager': 1,
                        'admin_status': 'Inactive'
                    },
                }
            })
            .then(response => {  
                  let uid = response.data.uid;
                  let accountId = response.data.accountId;
                  let email = response.data.email;
                this.$store.dispatch('create_account', { uid, accountId, email })
                this.flash({ message: "Account created successfully!", variant: 'success' });      
                this.$store.dispatch('create_account_obj', '');                      
                this.$router.push({ name: 'mmCreateAccountVerify'})
            })
            .catch(error => {

            });


    },
    onSubmitTab3(scope) {
      this.create_account_error_msg = '';
      this.$validator.validateAll(scope).then((result) => {
        if (!result) {
          console.log("ERROR" + result)
          return;
        }
        else {
          axios('/custom/checkAccountNameExists/' + this.create_account_obj.account_name,
            {
                method: 'GET', 
            })
            .then(response => {                
              this.$store.dispatch('create_account_obj', this.create_account_obj);              
              this.insertAccountUserAction();
            })
            .catch(error => {
              const fieldErrors =  [];
              var error_msg = error.response.data.message;
              var data_array = error_msg.split(',');
              for(var i=0; i<data_array.length; i++) {
                var data_array_value = data_array[i];
                data_array_value = data_array_value.replace("{", "");
                data_array_value = data_array_value.replace("}", "");
                data_array_value = "{"+data_array_value+"}";
                var errMsgObj = JSON.parse(data_array_value);
                Object.keys(errMsgObj).map(key => {
                  var fieldName = scope+'.'+key;
                  var newFieldErr = {field:fieldName, msg:errMsgObj[key], rule:'exists'};
                  fieldErrors.push(newFieldErr);
                  this.$validator.errors.add(fieldErrors);
                });
              }
            });
        }
        
      }).catch(() => {
        // catches the error;
      });
    },
    getPostalCodeRegex: function () {
      if (this.create_account_obj.org_country == "US") {
        return /^[0-9]{5}(?:-[0-9]{4})?$/;
      } else if (this.create_account_obj.org_country == "CA") {
        return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
      }
      return /./;
    },
    getCountryLists: function () {
      axios.get('/custom/account-create-country-lists', {

      })
        .then(response => {
          this.country_options = response.data;
        })
        .catch(function (error) {

        });
    },
    getStateLists: function (CountryCode) {
      this.create_account_obj.org_state = '';
      if (CountryCode == '') {
        CountryCode = null;
      }
      axios.get('/custom/get-state-lists/' + CountryCode, {

      })
        .then(response => {
          response.data[0].text = "State";
          this.state_options = response.data;
        })
        .catch(function (error) {

        });
    },
    placeAddressComponent: function (addressComponents) {
      var assocArray = [];
      for (var i = 0; i < addressComponents.length; i++) {
        var data_value = addressComponents[i].short_name;
        var data_key = addressComponents[i].types[0];
        assocArray[data_key] = data_value;
      }
      this.create_account_obj.org_zip = this.create_account_obj.org_city = this.create_account_obj.org_country = this.create_account_obj.org_state = this.create_account_obj.org_address = this.create_account_obj.org_address2 = '';
      if (assocArray['postal_code']) {
        this.create_account_obj.org_zip = assocArray['postal_code'];
      }
      if (assocArray['locality']) {
        this.create_account_obj.org_city = assocArray['locality'];
      }
      if (assocArray['country']) {
        this.create_account_obj.org_country = assocArray['country'];
        this.getStateLists(this.create_account_obj.org_country);
      }
      if (assocArray['administrative_area_level_1']) {
        this.create_account_obj.org_state = assocArray['administrative_area_level_1'];
      }
      if (assocArray['street_number']) {
        this.create_account_obj.org_address = assocArray['street_number'];
      }
      if (assocArray['route']) {
        if (this.create_account_obj.org_address) {
          this.create_account_obj.org_address = this.create_account_obj.org_address + ' ' + assocArray['route'];
        }
        else {
          this.create_account_obj.org_address = assocArray['route'];
        }
      }
    },
    placeOrgName: function (orgName) {
      if (orgName) {
        this.create_account_obj.account_name = orgName;
      }      
    },
  },
  created() {
    this.fetchIndustryOptions();
    this.getCountryLists();
    if(this.$store.state.create_account_obj) {
      this.create_account_obj = this.$store.state.create_account_obj;
      //this.create_account_obj.password = '';
      //this.create_account_obj.confirm_password = '';
    }
    this.getStateLists(this.create_account_obj.org_country);

  },
  mounted() {
    setTimeout(() => {
      this.autocomplete = new google.maps.places.Autocomplete(
        (this.$refs.location_api),
        {
          types: [],
          componentRestrictions: { country: ['us', 'ca'] },
        }
      );
      this.autocomplete.addListener('place_changed', () => {
        let place = this.autocomplete.getPlace();
        this.placeAddressComponent(place.address_components);
        this.placeOrgName(place.name);
      });
    }, 1000);
  },
  beforeCreate() {
    let googlePlaceAPI = document.createElement('script');
    googlePlaceAPI.setAttribute('src', "https://maps.googleapis.com/maps/api/js?key=" + process.env.PLACE_API_KEY + "&libraries=places");
    document.head.appendChild(googlePlaceAPI);
  },
}
</script>

<style scoped>
/deep/ .create_account_form_navs .create_account_form_tab {
  height: 10px;
  width: 100%;
  border: 2px solid #072435;
}

/deep/ .create_account_form_navs .create_account_form_tab.active {
  background-color: #072435;
}
.btn-blue {
  font-size: 18px;
  padding: 2px 30px 2px 30px;
  border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/create_account/form.vue